var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"pa-5"},_vm._l((_vm.apps),function(app){return _c('v-col',{key:app.title,staticClass:"col-sm-4"},[_c('AppTile',{attrs:{"appDetails":app}})],1)}),1),_c('v-row')],1)}
var staticRenderFns = []

export { render, staticRenderFns }